// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"295":"df68fabf","455":"dc744c17"}[chunkId] + ".chunk.css";
};